import { render, staticRenderFns } from "./studentWithQrcode.vue?vue&type=template&id=274f4557&scoped=true&"
import script from "./studentWithQrcode.vue?vue&type=script&lang=js&"
export * from "./studentWithQrcode.vue?vue&type=script&lang=js&"
import style0 from "./studentWithQrcode.vue?vue&type=style&index=0&id=274f4557&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f4557",
  null
  
)

export default component.exports